import { api } from "./client.js";

export interface ProfileUser {
  id: string;
  name: string;
  handle: string | null;
  bio: string | null;
  pronouns: string | null;
  city: string | null;
  country: string | null;
  country_code: string | null;
  timezone: string | null;
  latitude: number | null;
  longitude: number | null;
  working_start: string | null;
  working_end: string | null;
  status: string | null;
  default_visibility?: string;
}

export const profileApi = {
  get: (id: string) =>
    api.get<{ user: ProfileUser; interests: string[]; isSelf: boolean }>(`/api/users/${id}`),
  update: (id: string, patch: Partial<ProfileUser>) =>
    api.patch<{ user: ProfileUser }>(`/api/users/${id}`, patch),
  setInterests: (id: string, tags: string[]) =>
    api.patch<{ interests: string[] }>(`/api/users/${id}/interests`, tags),
};
